import AxiosPackage from 'axios'
import store from '../store'
import qs from 'qs'
import { snakeCase, camelCase } from 'change-case'

let isRefreshing = false

const axios = AxiosPackage.create({
  baseURL: process.env.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

axios.interceptors.request.use(config => {
  const token = store.getters['auth/token'] ? localStorage.getItem('token') : ''
  if (!token) {
    config.headers = {
      Accept: config.headers.Accept || 'application/json'
    }
  } else {
    config.headers = {
      Authorization: `Bearer ${token}`,
      Accept: config.headers.Accept || 'application/json'
    }
    config.paramsSerializer = params => {
      // // console.log('params: ', params)
      if (params) {
        const newParams = Object.keys(params).reduce((obj, key) => {
          // -- SORT -------
          if (key === 'sort' && !!params[key]) {
            // // console.log(`-- handle sort key by splitting ,: ${key}`)
            obj[key] = params[key]
              .split(',')
              .map(v => {
                // let newV = camelCase(v.trim())
                let newV = v.trim()
                if (v.indexOf('-') !== -1) {
                  newV = `-${newV}`
                }
                return newV
              })
              .join(',')
            // // console.log('--- UPDATE SORT KEY: ', params[key], obj[key])
            return obj
          }
          // -- FILTER -------
          if (key === 'filter' && !!params[key]) {
            const filters = params[key]
            obj[key] = Object.keys(filters).reduce((filterObj, filterKey) => {
              if (filters[filterKey]) {
                // -- if the value is an object (nested), we have a relation filter
                if (typeof filters[filterKey] === 'object') {
                  // -- camelCase this key
                  filterObj[camelCase(filterKey.trim())] = filters[filterKey]
                  return filterObj
                }
                // -- otherwise, snake case this
                filterObj[snakeCase(filterKey.trim())] = filters[filterKey]
                return filterObj
              }
              filterObj[filterKey] = filters[filterKey]
              return filterObj
            }, {})
            return obj
          }
          obj[key] = params[key]
          return obj
        }, {})
        return qs.stringify(newParams, { arrayFormat: 'brackets', encode: true })
      }
      // return qs.stringify(params, {arrayFormat: 'brackets', encode: true})
    }
  }
  return config
})

export default ({ Vue, app }) => {
  axios.interceptors.response.use(
    response => {
      return response
    },
    async error => {
      const {
        config,
        response: { status }
      } = error
      const originalRequest = config

      if (status === 401) {
        // // console.log('isRefreshing?', isRefreshing)
        if (!isRefreshing) {
          isRefreshing = true
          try {
            // // console.log('try: refreshUserToken', isRefreshing)
            await store.dispatch('auth/refreshUserToken', { client: axios })
            isRefreshing = false
            const newToken = store.getters['auth/token']
            return new Promise((resolve, reject) => {
              originalRequest.headers['Authorization'] = 'Bearer ' + newToken
              originalRequest.headers['Accept'] = 'application/json'
              resolve(axios(originalRequest))
            })
          } catch (e) {
            // // console.log('REFRESH ERROR, commit LOGOUT')
            store.commit('auth/LOGOUT_USER')
            window.location = '/auth/login'
          }
        }
      } else {
        /*
        app.$router.push({
          path: '/auth/login',
          query: { inactivity: true },
          params: { returnUrl: app.$route.path }
        })
       */
        return Promise.reject(error)
      }
    }
  )
  Vue.prototype.$axios = axios
}

export { axios }
